import React, { useEffect, useRef, useState } from 'react'
import Icon from '../Icon'
import Button from './Button'
import './ui.css'

function ActionMenu ({
  label = 'Действия',
  items = [],
  align = 'right',
  variant = 'secondary',
  className = ''
}) {
  const [open, setOpen] = useState(false)
  const rootRef = useRef(null)
  const visibleItems = items.filter(Boolean)

  useEffect(() => {
    if (!open) return undefined

    const handlePointerDown = (event) => {
      if (!rootRef.current?.contains(event.target)) {
        setOpen(false)
      }
    }
    const handleKeyDown = (event) => {
      if (event.key === 'Escape') setOpen(false)
    }

    document.addEventListener('pointerdown', handlePointerDown)
    document.addEventListener('keydown', handleKeyDown)
    return () => {
      document.removeEventListener('pointerdown', handlePointerDown)
      document.removeEventListener('keydown', handleKeyDown)
    }
  }, [open])

  if (!visibleItems.length) return null

  const menuClass = `ds-action-menu__popup ds-action-menu__popup--${align === 'left' ? 'left' : 'right'}`

  return (
    <div ref={rootRef} className={`ds-action-menu ${open ? 'ds-action-menu--open' : ''} ${className}`.trim()}>
      <Button
        type="button"
        variant={variant}
        className="ds-action-menu__trigger"
        aria-haspopup="menu"
        aria-expanded={open}
        onClick={() => setOpen((value) => !value)}
      >
        {label}
        <span className="ds-action-menu__chevron" aria-hidden>
          <Icon name="chevronDown" size={12} />
        </span>
      </Button>
      {open && (
        <div className={menuClass} role="menu">
          {visibleItems.map((item) => {
            if (item.type === 'divider') {
              return <div key={item.id || item.label} className="ds-action-menu__divider" role="separator" />
            }
            return (
              <button
                key={item.id || item.label}
                type="button"
                role="menuitem"
                className={[
                  'ds-action-menu__item',
                  item.danger || item.tone === 'danger' ? 'ds-action-menu__item--danger' : '',
                  item.success || item.tone === 'success' ? 'ds-action-menu__item--success' : '',
                  item.tone === 'warning' ? 'ds-action-menu__item--warning' : '',
                ].filter(Boolean).join(' ')}
                disabled={item.disabled}
                onClick={() => {
                  setOpen(false)
                  item.onSelect?.()
                }}
              >
                {item.icon && <span className="ds-action-menu__icon" aria-hidden>{item.icon}</span>}
                <span>{item.label}</span>
              </button>
            )
          })}
        </div>
      )}
    </div>
  )
}

export default ActionMenu
